var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#EBF6EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 81.5C48.14 81.5 38.5 71.86 38.5 60C38.5 48.14 48.14 38.5 60 38.5C71.86 38.5 81.5 48.14 81.5 60C81.5 71.86 71.86 81.5 60 81.5ZM60 41.5C49.8 41.5 41.5 49.8 41.5 60C41.5 70.2 49.8 78.5 60 78.5C70.2 78.5 78.5 70.2 78.5 60C78.5 49.8 70.2 41.5 60 41.5Z",
    fill: "#008908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1599 67.1592C56.7599 67.1592 56.3799 66.9992 56.0999 66.7192L50.4399 61.0592C49.8599 60.4792 49.8599 59.5192 50.4399 58.9392C51.0199 58.3592 51.9799 58.3592 52.5599 58.9392L57.1599 63.5392L67.4399 53.2592C68.0199 52.6792 68.9799 52.6792 69.5599 53.2592C70.1399 53.8392 70.1399 54.7992 69.5599 55.3792L58.2199 66.7192C57.9399 66.9992 57.5599 67.1592 57.1599 67.1592Z",
    fill: "#008908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSuccessIcon);
export default __webpack_public_path__ + "static/media/create-success-icon.63c121a7.svg";
export { ForwardRef as ReactComponent };